const body = document.body;

/**
 *
 * Global Scripts
 *
 **/

/////////Navigation Hambuger Style/////////

const toggleBtn = document.querySelector(".tenc-menu-toggle");
const navLinks = document.querySelector(".tenc-nav-links");

toggleBtn.addEventListener("click", () => {
    navLinks.classList.toggle("open");
});

const elements = document.querySelectorAll(".animate-up");

const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("in-view");
                observer.unobserve(entry.target);
            }
        });
    },
    { threshold: 0.1 }
);

elements.forEach((el) => observer.observe(el));

/////////Navigation Animation Scroll Up/////////

document.querySelectorAll(".nav-link-text-wrap").forEach((wrap) => {
    wrap.addEventListener("mouseenter", () => {
        const targets = wrap.querySelectorAll(".nav-link-text");

        // Reset animation
        targets.forEach((el) => {
            el.classList.remove("is-animated");
            el.style.animation = "none"; // clear animation property
            el.offsetHeight; // trigger reflow
            el.style.animation = ""; // allow re-animation
        });

        // Re-apply animation class
        wrap.classList.add("is-animated");
    });
});

/////////Button Animation Scroll Up/////////

document.querySelectorAll(".button-animate-wrap").forEach((wrap) => {
    wrap.addEventListener("mouseenter", () => {
        const targets = wrap.querySelectorAll(
            ".button-text-wrap, .button-arrow-wrap"
        );

        targets.forEach((el) => {
            el.classList.remove("is-animated");
            void el.offsetWidth; // force reflow reliably (offsetWidth is better than offsetHeight here)
            el.classList.add("is-animated");
        });
    });
});

/**
 *
 * Page Specific Scripts
 *
 **/

/////////Title Animation/////////

if (
    body.classList.contains("about-page") ||
    body.classList.contains("services-page") ||
    body.classList.contains("contact-page") ||
    body.classList.contains("index-page")
) {
    const heading = document.getElementById("animated-heading");
    const text = heading.textContent;
    
    // Helper to rebuild and animate
    function renderHeading() {
      heading.innerHTML = "";
    
      if (window.innerWidth <= 600) {
        // ✅ MOBILE: Break on hyphens
        text.split(" ").forEach((word) => {
          const parts = word.split("-");
          parts.forEach((part, index) => {
            const wordSpan = document.createElement("span");
            wordSpan.classList.add("word");
    
            part.split("").forEach((char) => {
              const charSpan = document.createElement("span");
              charSpan.classList.add("char");
              charSpan.textContent = char;
              wordSpan.appendChild(charSpan);
            });
    
            heading.appendChild(wordSpan);
    
            if (index < parts.length - 1) {
              const hyphenSpan = document.createElement("span");
              hyphenSpan.classList.add("char");
              hyphenSpan.textContent = "-";
              heading.appendChild(hyphenSpan);
            }
          });
        });
      } else {
        // ✅ DESKTOP: Treat hyphenated words as one unit
        text.split(" ").forEach((word) => {
          const wordSpan = document.createElement("span");
          wordSpan.classList.add("word");
    
          word.split("").forEach((char) => {
            const charSpan = document.createElement("span");
            charSpan.classList.add("char");
            charSpan.textContent = char;
            wordSpan.appendChild(charSpan);
          });
    
          heading.appendChild(wordSpan);
        });
      }
    
      // Animate characters
      gsap.from("#animated-heading .char", {
        opacity: 0,
        // y: 30,
        stagger: 0.03,
        ease: "power3.out",
        duration: 0.3,
      });
    }
    
    // --- Initial render ---
    renderHeading();
    
    // --- Re-run if user crosses 600px breakpoint ---
    let currentIsMobile = window.innerWidth <= 600;
    
    window.addEventListener("resize", () => {
      const isMobile = window.innerWidth <= 600;
    
      if (isMobile !== currentIsMobile) {
        currentIsMobile = isMobile;
        renderHeading(); // re-render if we crossed the breakpoint
      }
    });
    
}

/////////Portfolio Items Animate Up on Scroll/////////

if (body.classList.contains("portfolio-page")) {
    const observer1 = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const index = parseInt(el.dataset.index, 10);
                    el.style.transitionDelay = `${index * 100}ms`; // 100ms per item stagger
                    el.classList.add("is-animated");
                    observer1.unobserve(el); // trigger once
                }
            });
        },
        { threshold: 0.1 }
    );

    document
        .querySelectorAll(".portfolio-s1-grid-item.animate-up")
        .forEach((el) => {
            observer1.observe(el);
        });
}

  gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray('video[data-play-mid]').forEach((video) => {
  video.muted = true;
  video.playsInline = true;

  // Encourage iOS to fetch enough to paint a frame
  video.preload = 'metadata';
  try { video.load(); } catch (e) {}

  const triggerEl = video.closest('.tenc-video-wrapper') || video;

  let ready = false;
  let hasPlayedOnce = false;

  const armVideo = () => {
    // called once metadata exists
    ready = true;

    // iOS: setting 0 can be problematic; 0.001 is the “first frame” trick
    try { video.currentTime = 0.001; } catch (e) {}

    ScrollTrigger.refresh();
  };

  if (video.readyState >= 1) armVideo();
  else video.addEventListener('loadedmetadata', armVideo, { once: true });

  const safePauseAndReset = () => {
    // Don't reset before it's ready or before it's ever played (prevents blank render)
    if (!ready || !hasPlayedOnce) return;
    video.pause();
    try { video.currentTime = 0.001; } catch (e) {}
  };

  const safePlayFromStart = () => {
    if (!ready) return;

    // Start from near-zero so Safari paints immediately
    try { video.currentTime = 0.001; } catch (e) {}

    const p = video.play();
    if (p && p.catch) p.catch(() => {});
    hasPlayedOnce = true;
  };

  // 1) Play when crossing viewport mid
  ScrollTrigger.create({
    trigger: triggerEl,
    start: "top 50%",
    end: "bottom 50%",
    onEnter: safePlayFromStart,
    onEnterBack: safePlayFromStart,
    onLeave: () => video.pause(),
    onLeaveBack: () => video.pause(),
  });

  // 2) Reset ONLY when fully off-screen
  ScrollTrigger.create({
    trigger: triggerEl,
    start: "bottom top",
    onEnter: safePauseAndReset,
  });

  ScrollTrigger.create({
    trigger: triggerEl,
    start: "top bottom",
    onLeaveBack: safePauseAndReset,
  });
});